import React, { useEffect, useState } from "react";
import { User } from "src/types/user";
import { useRouter } from "next/router";
import { FlexVerticalContainer } from "./style/AffiliatePage.style";
import { BannerSlider } from "./BannerSlider/BannerSlider";
import AffiliateDescription from "./AffiliateDescription";
import AffiliateReport from "./AffiliateReport/AffiliateReport";
import FAQSection from "./FAQSection/FAQSection";
import TutorialStep from "./TutorialStep/TutorialStep";
import { GuideBook } from "./GuideBook/GuideBook";
import { VideoSection } from "./VideoSection/VideoSection";
import { RegisterSection } from "./RegisterSection/RegisterSection";
import { UserProfileSection } from "./UserProfileSection/UserProfileSection";

type AffiliatePageProps = {
  channelConfig: any;
  user: User | null;
};
const AffiliatePage = ({ channelConfig, user }: AffiliatePageProps) => {
  const router = useRouter();

  const [hash, setHash] = useState("");
  const [activeFaqTab, setActiveFaqTab] = useState("1");

  useEffect(() => {
    const handleUrlChange = () => {
      const newHash = window.location.hash.replace("#", "");
      setHash(newHash);
    };

    // Handle initial load
    handleUrlChange();

    // Listen for hash changes
    window.addEventListener("hashchange", handleUrlChange);

    // Listen for Next.js route changes
    router.events.on("hashChangeComplete", handleUrlChange);

    return () => {
      window.removeEventListener("hashchange", handleUrlChange);
      router.events.off("hashChangeComplete", handleUrlChange);
    };
  }, [router]);

  useEffect(() => {
    if (hash) {
      if (hash.startsWith("faq")) {
        const activeTab = hash.slice(-1);
        setActiveFaqTab(activeTab);
        scrollToElement("faq");
      } else {
        scrollToElement(hash);
      }
    }
  }, [hash]);

  const scrollToElement = (id: string) => {
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 1000);
  };

  return (
    <>
      <FlexVerticalContainer style={{ padding: "24px 0px" }} rowGap="24px">
        <AffiliateDescription />

        {!user && <UserProfileSection />}

        <RegisterSection user={user} />

        <AffiliateReport channelConfig={channelConfig} user={user} />

        <BannerSlider />

        <TutorialStep />

        <VideoSection />

        <GuideBook />

        <FAQSection activeTab={activeFaqTab} setActiveTab={setActiveFaqTab} />
      </FlexVerticalContainer>
    </>
  );
};

export default AffiliatePage;
